var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95052 10.2959V9.94194C4.95052 8.77394 4.95052 7.60594 4.95052 6.44194C4.93152 6.10866 4.98317 5.77512 5.10209 5.4632C5.221 5.15128 5.4045 4.86801 5.64054 4.63196C5.87659 4.39592 6.15986 4.21242 6.47178 4.0935C6.78371 3.97459 7.11724 3.92294 7.45052 3.94194C10.4779 3.94194 13.5055 3.94194 16.5335 3.94194C16.8676 3.92146 17.2022 3.97201 17.5153 4.09028C17.8283 4.20855 18.1128 4.39184 18.3499 4.62806C18.5869 4.86429 18.7713 5.14809 18.8907 5.46075C19.01 5.77341 19.0618 6.10782 19.0425 6.44194C19.0425 7.54194 19.0425 8.63494 19.0425 9.73094V10.0689H19.3735C20.3795 10.0689 21.3875 10.1039 22.3915 10.0569C22.5654 10.0676 22.7347 10.1168 22.8872 10.2009C23.0397 10.2851 23.1717 10.402 23.2735 10.5433C23.3753 10.6847 23.4444 10.8468 23.4759 11.0182C23.5074 11.1895 23.5004 11.3656 23.4555 11.5339C23.3975 11.7199 23.2826 11.883 23.1271 12.0003C22.9716 12.1176 22.7833 12.1832 22.5885 12.1879C22.4985 12.1939 22.4085 12.1879 22.3185 12.1879H1.62452C1.53452 12.1879 1.44452 12.1879 1.35552 12.1879C1.23215 12.1887 1.11006 12.1629 0.997577 12.1123C0.885091 12.0616 0.784854 11.9873 0.703701 11.8943C0.622549 11.8014 0.56239 11.6921 0.527326 11.5738C0.492263 11.4555 0.48312 11.3311 0.500521 11.2089C0.499322 11.0894 0.521948 10.9708 0.56708 10.8601C0.612211 10.7494 0.678943 10.6488 0.763379 10.5642C0.847815 10.4796 0.948263 10.4126 1.05886 10.3673C1.16945 10.3219 1.28798 10.299 1.40752 10.2999C2.47652 10.2909 3.54552 10.2999 4.61452 10.2999H4.95052",
    fill: "url(#paint0_linear_319_855)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97261 13.6035H18.9926C19.0407 14.4664 19.0333 15.3315 18.9706 16.1935C18.8834 16.7195 18.6106 17.1969 18.2017 17.539C17.7927 17.8812 17.2748 18.0655 16.7416 18.0585C13.5783 18.0725 10.4149 18.0725 7.25161 18.0585C6.67769 18.0564 6.12561 17.8382 5.70532 17.4474C5.28502 17.0566 5.02735 16.5218 4.98362 15.9495C4.92662 15.1745 4.97261 14.3915 4.97261 13.6035Z",
    fill: "url(#paint1_linear_319_855)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9655 0.607422C18.5657 0.608353 19.1651 0.650116 19.7595 0.732422C20.4878 0.885343 21.1411 1.28459 21.6094 1.86291C22.0777 2.44123 22.3324 3.16327 22.3305 3.90742C22.3515 4.68842 22.3435 5.47042 22.3305 6.25142C22.3488 6.38212 22.3369 6.51528 22.2957 6.64067C22.2546 6.76606 22.1852 6.88035 22.093 6.97478C22.0008 7.0692 21.8882 7.14125 21.7638 7.18539C21.6395 7.22953 21.5066 7.2446 21.3755 7.22942C21.2469 7.23064 21.1194 7.20471 21.0015 7.15333C20.8835 7.10196 20.7778 7.02629 20.691 6.93126C20.6043 6.83623 20.5386 6.72399 20.4982 6.60185C20.4578 6.47971 20.4436 6.35042 20.4565 6.22242C20.4565 5.51242 20.4565 4.80342 20.4565 4.09342C20.4759 3.88406 20.4491 3.67301 20.378 3.47515C20.3069 3.27728 20.1932 3.09744 20.045 2.94829C19.8968 2.79915 19.7177 2.68433 19.5203 2.61196C19.3229 2.53959 19.112 2.51141 18.9025 2.52942C18.1665 2.52942 17.4295 2.53642 16.6935 2.52942C16.4663 2.53432 16.2455 2.45401 16.0745 2.30429C15.9035 2.15458 15.7947 1.9463 15.7695 1.72042C15.7307 1.48711 15.7835 1.24782 15.9169 1.05253C16.0503 0.85724 16.2541 0.721054 16.4855 0.672422C16.5823 0.653316 16.6809 0.644932 16.7795 0.647422C17.1795 0.647422 17.5695 0.647422 17.9645 0.647422C17.9645 0.635422 17.9645 0.624422 17.9645 0.612422",
    fill: "url(#paint2_linear_319_855)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02449 21.3938C5.42457 21.392 4.82549 21.3489 4.23149 21.2648C3.50826 21.1118 2.85944 20.7152 2.39349 20.1413C1.92753 19.5674 1.67267 18.851 1.67149 18.1118C1.64749 17.3218 1.65449 16.5308 1.67149 15.7408C1.6631 15.5778 1.6976 15.4154 1.77155 15.27C1.84551 15.1245 1.95633 15.0009 2.09295 14.9117C2.22958 14.8224 2.38722 14.7706 2.55016 14.7613C2.71309 14.752 2.87561 14.7856 3.02149 14.8588C3.18641 14.9344 3.3246 15.0582 3.41794 15.2138C3.51127 15.3694 3.55538 15.5496 3.54449 15.7307C3.54449 16.4587 3.54449 17.1857 3.54449 17.9137C3.52612 18.1231 3.55388 18.334 3.62581 18.5315C3.69774 18.729 3.8121 18.9084 3.96082 19.0569C4.10955 19.2054 4.28903 19.3195 4.48662 19.3912C4.68422 19.4629 4.89513 19.4904 5.10449 19.4718C5.80449 19.4718 6.50449 19.4718 7.20449 19.4718C7.33558 19.4592 7.46784 19.4741 7.59284 19.5155C7.71784 19.557 7.83282 19.624 7.93044 19.7124C8.02807 19.8008 8.10618 19.9085 8.1598 20.0288C8.21343 20.1491 8.24137 20.2792 8.24186 20.4109C8.24235 20.5426 8.21537 20.6729 8.16264 20.7936C8.10991 20.9143 8.0326 21.0226 7.93564 21.1117C7.83867 21.2008 7.72419 21.2687 7.5995 21.3111C7.47482 21.3535 7.34267 21.3693 7.21149 21.3577C6.81149 21.3577 6.42149 21.3577 6.02649 21.3577V21.3938",
    fill: "url(#paint3_linear_319_855)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3675 17.0443C22.3597 17.6176 22.318 18.19 22.2425 18.7583C22.097 19.4828 21.7081 20.1357 21.1404 20.6086C20.5727 21.0815 19.8603 21.3461 19.1215 21.3583C18.3135 21.3703 17.5055 21.3653 16.6975 21.3583C16.5735 21.371 16.4483 21.3563 16.3306 21.3153C16.2129 21.2743 16.1057 21.2079 16.0164 21.121C15.9272 21.034 15.8581 20.9285 15.8141 20.812C15.77 20.6954 15.7521 20.5706 15.7615 20.4463C15.7534 20.3201 15.7716 20.1936 15.8151 20.0749C15.8586 19.9561 15.9263 19.8477 16.014 19.7565C16.1017 19.6654 16.2074 19.5935 16.3244 19.5454C16.4413 19.4974 16.567 19.4742 16.6935 19.4773C17.4475 19.4653 18.2015 19.4773 18.9565 19.4773C19.155 19.488 19.3535 19.457 19.5393 19.3863C19.7251 19.3157 19.8941 19.2069 20.0354 19.0671C20.1766 18.9272 20.2871 18.7593 20.3596 18.5742C20.4321 18.3892 20.4651 18.1909 20.4565 17.9923C20.4625 17.2643 20.4565 16.5373 20.4565 15.8093C20.4408 15.6795 20.4531 15.5478 20.4923 15.423C20.5315 15.2983 20.5969 15.1833 20.684 15.0857C20.7711 14.9882 20.878 14.9103 20.9976 14.8573C21.1172 14.8043 21.2467 14.7774 21.3775 14.7783C21.6403 14.79 21.8878 14.9048 22.0666 15.0978C22.2454 15.2908 22.3409 15.5464 22.3325 15.8093C22.3385 16.2223 22.3325 16.6353 22.3325 17.0493H22.3665",
    fill: "url(#paint4_linear_319_855)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06168 0.642825C6.46168 0.642825 6.86968 0.642825 7.27368 0.642825C7.39983 0.636299 7.52596 0.655935 7.64415 0.700497C7.76235 0.74506 7.87005 0.813587 7.96049 0.901771C8.05093 0.989956 8.12215 1.09589 8.16968 1.21292C8.21721 1.32996 8.24002 1.45555 8.23668 1.58182C8.24068 1.7082 8.2185 1.83404 8.17153 1.95143C8.12456 2.06882 8.05383 2.17523 7.96377 2.26398C7.87371 2.35272 7.76627 2.42188 7.6482 2.46712C7.53013 2.51235 7.40398 2.53268 7.27768 2.52682C6.52368 2.53582 5.76868 2.52682 5.01468 2.52682C4.82083 2.52007 4.62766 2.55307 4.44705 2.62379C4.26644 2.69451 4.10222 2.80146 3.9645 2.93805C3.82679 3.07464 3.7185 3.23798 3.6463 3.41801C3.57409 3.59803 3.53951 3.79093 3.54468 3.98482C3.53568 4.72182 3.54468 5.45782 3.54468 6.19482C3.56095 6.32537 3.5491 6.45789 3.50992 6.58348C3.47074 6.70906 3.40514 6.82481 3.31752 6.92295C3.2299 7.02108 3.12229 7.09933 3.00193 7.15243C2.88156 7.20553 2.75123 7.23226 2.61968 7.23082C2.35707 7.21861 2.10982 7.10347 1.93147 6.91033C1.75311 6.71719 1.65798 6.46158 1.66668 6.19882C1.66668 5.33682 1.63668 4.47182 1.69868 3.61382C1.78672 2.81604 2.15926 2.07668 2.74807 1.53122C3.33687 0.985761 4.1025 0.670722 4.90468 0.643825C5.29068 0.638825 5.67668 0.643825 6.06368 0.643825",
    fill: "url(#paint5_linear_319_855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_855",
    x1: 0.491943,
    y1: 8.06405,
    x2: 23.4953,
    y2: 8.06405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_855",
    x1: 4.95508,
    y1: 15.8363,
    x2: 19.0239,
    y2: 15.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_855",
    x1: 15.7571,
    y1: 3.92129,
    x2: 22.3435,
    y2: 3.92129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_855",
    x1: 1.65601,
    y1: 18.0768,
    x2: 8.24187,
    y2: 18.0768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_319_855",
    x1: 15.759,
    y1: 18.072,
    x2: 22.3675,
    y2: 18.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_319_855",
    x1: 1.65942,
    y1: 3.93624,
    x2: 8.23714,
    y2: 3.93624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientScanIcon);
export default __webpack_public_path__ + "static/media/gradient-scan-icon.62a0d67327132bba01bea22c12d9670b.svg";
export { ForwardRef as ReactComponent };